import moment from "moment";

if (localStorage.getItem("i18nextLng") === "fr") {
  require("./momentFr");
}
export default moment;
